import { defineStore } from 'pinia';
import { appsApiService } from 'src/services';

export const useInsightStore = defineStore('insight', {
  state: () => ({
    active: '' as string,
  }),
  getters: {
    getStatus(state) {
      return state.active;
    },
  },
  actions: {
    async getSettings() {
      const response = await appsApiService.getSettings({ app: 'insight' });
      this.active = response.active;
    },
  },
});
